







import Vue from 'vue'   

import { routerReplace } from '../helpers';
import { setSort } from '../store/actions';
import { ISort } from '../store/state';

interface SortMethods {
    test(): void
}

interface SortProperty {
	
}
interface SortComputed {
   sorts: ISort[]
   sort: any
}

export default Vue.extend<{}, SortMethods, SortComputed , SortProperty>({
	name: 'Sort',
    computed: {
        sorts() {
            return this.$store.getters.sorts
        },
        sort: {
            get() {
                const activeOption = this.$store.getters.sorts.find((s: any) => (s.active as any));
                return activeOption?.name;
            },
            set(value) {
                this.$store.dispatch(setSort(value))
                routerReplace({
				    query: this.$store.getters.getParams
			    })
            }   
        },
        
    }
})
